
const digest = '79e1796e824fb43266b601d274b2b42519f2f49efc511cd6c6d73b7e6d0ba314';
const classes = {"box":"_box_136jg_1","selected":"_selected_136jg_12","warning":"_warning_136jg_16","depth":"_depth_136jg_16","margin":"_margin_136jg_20","title":"_title_136jg_24"};
const css = `._box_136jg_1 {
  min-height: 96px;
  padding: 8px;
  cursor: pointer;
  border-radius: 6px;
  box-shadow: inset 0 0 0 1px #e6e7eb;
  position: relative;
  flex-direction: column;
  height: 100%;
}

._selected_136jg_12 {
  box-shadow: inset 0 0 0 2px #98a1b3;
}

._warning_136jg_16 ._depth_136jg_16 {
  color: #e13830;
  border-bottom-color: #e13830;
}
._warning_136jg_16 ._margin_136jg_20 {
  color: #e13830;
  border-color: #e13830;
}
._warning_136jg_16 ._title_136jg_24 {
  color: #e13830;
}

._depth_136jg_16 {
  font-size: 32px;
  line-height: 38px;
  letter-spacing: 0.19px;
  border-bottom: 1px solid #4d5565;
  padding-bottom: 12px;
  margin-bottom: 2px;
  font-weight: 300;
  color: #4d5565;
  border-bottom-color: #d0d3d9;
}

._margin_136jg_20 {
  font-size: 12px;
  line-height: 16px;
  letter-spacing: normal;
  width: 38px;
  height: 18px;
  border: 1px solid #d0d3d9;
  border-radius: 9px;
  margin: -12px auto 5px;
  background: #fff;
  color: #d0d3d9;
}

._title_136jg_24 {
  font-size: 11px;
  line-height: 16px;
  letter-spacing: normal;
  font-weight: 600;
  order: 1;
  margin-bottom: 0;
  color: #7a8599;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  